import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../contexts/LanguageContext';
import { HiMail, HiPhone } from 'react-icons/hi';
import { FaLinkedin, FaGithub } from 'react-icons/fa';

const Contact: React.FC = () => {
  const { t } = useLanguage();
  return (
    <section id="contact" className="py-20 px-6 bg-dark-surface">
      <div className="container mx-auto max-w-4xl">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <h2 className="text-4xl font-bold mb-4">
            <span className="text-gradient">{t('contact.title')}</span>
          </h2>
          <p className="text-gray-400">{t('contact.subtitle')}</p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="bg-dark-card rounded-lg p-8 shadow-xl"
        >
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <motion.a
              href="mailto:hyunwoo892579@gmail.com"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center space-x-4 p-4 bg-dark-surface rounded-lg hover:bg-dark-bg transition-colors group"
              whileHover={{ scale: 1.05 }}
            >
              <div className="bg-blue-500/20 p-3 rounded-lg group-hover:bg-blue-500/30 transition-colors">
                <HiMail className="text-2xl text-blue-400" />
              </div>
              <div>
                <p className="text-sm text-gray-400 mb-1">{t('contact.email')}</p>
                <p className="text-white font-semibold group-hover:text-blue-400 transition-colors">
                  hyunwoo892579@gmail.com
                </p>
              </div>
            </motion.a>

            <motion.a
              href="tel:01049177671"
              className="flex items-center space-x-4 p-4 bg-dark-surface rounded-lg hover:bg-dark-bg transition-colors group"
              whileHover={{ scale: 1.05 }}
            >
              <div className="bg-green-500/20 p-3 rounded-lg group-hover:bg-green-500/30 transition-colors">
                <HiPhone className="text-2xl text-green-400" />
              </div>
              <div>
                <p className="text-sm text-gray-400 mb-1">{t('contact.phone')}</p>
                <p className="text-white font-semibold group-hover:text-green-400 transition-colors">
                  010-4917-7671
                </p>
              </div>
            </motion.a>

            <motion.a
              href="https://www.linkedin.com/in/hyunwoo-lim-38aaa8294"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center space-x-4 p-4 bg-dark-surface rounded-lg hover:bg-dark-bg transition-colors group"
              whileHover={{ scale: 1.05 }}
            >
              <div className="bg-blue-600/20 p-3 rounded-lg group-hover:bg-blue-600/30 transition-colors">
                <FaLinkedin className="text-2xl text-blue-500" />
              </div>
              <div>
                <p className="text-sm text-gray-400 mb-1">{t('contact.linkedin')}</p>
                <p className="text-white font-semibold group-hover:text-blue-500 transition-colors">
                  LinkedIn Profile
                </p>
              </div>
            </motion.a>

            <motion.a
              href="https://github.com/imenuuu"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center space-x-4 p-4 bg-dark-surface rounded-lg hover:bg-dark-bg transition-colors group"
              whileHover={{ scale: 1.05 }}
            >
              <div className="bg-gray-700/20 p-3 rounded-lg group-hover:bg-gray-700/30 transition-colors">
                <FaGithub className="text-2xl text-gray-300" />
              </div>
              <div>
                <p className="text-sm text-gray-400 mb-1">{t('contact.github')}</p>
                <p className="text-white font-semibold group-hover:text-gray-300 transition-colors">
                  github.com/imenuuu
                </p>
              </div>
            </motion.a>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Contact;
